import  React, {Component} from 'react';
import UserSummary from '../UserSummary/UserSummary';
import './PrintWorkOrder.css';

class ComponentToPrint extends Component {
    state ={
        woLUID : ''
    }

  render() {
      var workOrder = this.props.woDetails;
    //  alert(workOrder.WorkOrderLUID);

      
    return (
     <div className="print-boarder">
                {  }

        <div className = "content-margin ">
            <div className ="image-margin">
                <img alt="" src="./edmonton-logo.png" width="100" height="100" className="d-inline-block align-top logo-margin-left"/>
            </div>
            <br/>
            <div>
                <h4>
                    <UserSummary showEditButton={false}/>
                </h4>
            </div>
            <br/>
            <br/>
            <div className ="order-margin">
                <h3>
                     Order {workOrder.workOrderLUID}
                </h3>
            </div>
            <br/>
            <br/>

            <div>
                <table>
                    <tbody>
                    <tr>
                        <td><h4>
                            Order Date:</h4>
                        </td>
                        <td><h4>
                            {workOrder.requestedDate}</h4>
                        </td>
                    </tr>
                    <tr>
                        <td> <h4>Request Type:</h4></td>
                        <td><h4>{workOrder.requestType}</h4></td>
                    </tr>
                    {workOrder.serialNumber === null || workOrder.serialNumber === "" ? null : 
                        <tr>
                            <td> <h4>Serial Number:</h4></td>
                            <td><h4>{workOrder.serialNumber}</h4></td>
                        </tr> 
                    }
                    {workOrder.workflowType === "Swap" ?  
                        <tr>
                            <td> <h4>Cart Size Requested:</h4></td>
                            <td><h4>{workOrder.cartSize}</h4></td>
                        </tr> : null
                    }
                    <tr>
                        <td><h4>Comment:</h4></td>
                        <td><h4>{workOrder.woNotes}</h4></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
     </div>
    );
  }
}

export default ComponentToPrint;